import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'bz-button-fab',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {
  @Input() tooltipText: string;
  @Input() type: string;
  @Input() bottom='';
  buttonStyles = [
    { type: 'add-property', bottom: '70px' },
    { type: 'save', bottom: '0px' }
  ];
  icon: string;
  replacementIcon: string;
  transform: string;
  additionalClass:string;
  listTypes = [
    { type: 'add-property',
      icon: 'bz-icon-plus-outline',
      replacementIcon: ' bz-icon-add-attribute',
      transform: 'bz-fab__transform' ,
      additionalClass :'bz-add-property' },
    { type: 'save',
      icon: ' bz-icon-save',
      replacementIcon: 'bz-fab__i_hide',
      transform: '' ,
      additionalClass : '' }
  ];

  constructor() { }

  ngOnInit() {
    this.getType();
    this.setButtonStyles();
  }

  getType() {
    const _type = this.listTypes.find(t => t.type === this.type);
    this.icon = _type.icon;
    this.replacementIcon = _type.replacementIcon;
    this.transform = _type.transform;
    this.additionalClass = _type.additionalClass;
  }

  setButtonStyles(){
    const _type = this.buttonStyles.find(t => t.type === this.type);
    this.bottom = this.bottom !== '' ? this.bottom : _type.bottom;
    return { 'bottom' : this.bottom }
  }

}
